/**
 * Lets an account that hasn't finished onboarding use the app for the rest of
 * this browser session without being sent to /onboarding — e.g. a guest who
 * signs up only to send an advisor a trip request. The next session (new tab,
 * app relaunch) goes through onboarding as usual.
 */

const STORAGE_KEY = 'gt_onboarding_deferred';

export function deferOnboardingForSession(): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // Storage unavailable (private mode): the user is sent to onboarding as usual.
  }
}

export function isOnboardingDeferred(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearOnboardingDeferral(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing stored.
  }
}
